import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

import './index.scss';
import { useNavigate } from 'react-router-dom';

const HeaderComponent = (props) => {
    const navigate = useNavigate();
    function logout() {
        localStorage.clear();
        navigate("/login");
    }
    return (
        <Navbar expand="lg" >
            <Container>
                <Navbar.Brand href="#home">PDF Signer</Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link href="/certificates">Certificates</Nav.Link>
                        <Nav.Link href="/signature">Signatures</Nav.Link>
                        <Nav.Link href="/test">Sign Document</Nav.Link>

                    </Nav>
                </Navbar.Collapse>
                <Navbar.Collapse className="justify-content-end">
                    <Nav>
                        <Nav.Link onClick={logout}>Logout</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default HeaderComponent;